import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import HelpIcon from 'ui-library/icons/HelpIcon';
interface FieldTableHeaderProps {
  // isDisabled hides the add button and the table delete button
  isDisabled: boolean;
  onAddField?: (() => void) | null;
  onAddToolTip?: string;
  toolTipIcon?: BenchlingIconName;
  shouldShowDefinition: boolean;
  shouldShowIsParentLink: boolean;
  shouldShowIsRequired: boolean;
  shouldShowMultiSelect: boolean;
  shouldShowIsIntegration: boolean;
  shouldShowTooltip: boolean;
  shouldShowWarehouseName: boolean;
  shouldShowAdditionalColumn?: boolean;
  subheader?: JSX.Element;
  title: string;
  helpText?: string;
}

// eslint-disable-next-line react/prefer-stateless-function
class FieldTableHeader extends React.Component<FieldTableHeaderProps> {
  static propTypes = {
    // isDisabled hides the add button and the table delete button
    isDisabled: PropTypes.bool.isRequired,
    onAddField: PropTypes.func,
    shouldShowDefinition: PropTypes.bool.isRequired,
    shouldShowIsParentLink: PropTypes.bool.isRequired,
    shouldShowIsRequired: PropTypes.bool.isRequired,
    shouldShowMultiSelect: PropTypes.bool.isRequired,
    shouldShowIsIntegration: PropTypes.bool.isRequired,
    shouldShowTooltip: PropTypes.bool.isRequired,
    shouldShowWarehouseName: PropTypes.bool.isRequired,
    shouldShowAdditionalColumn: PropTypes.bool,
    subheader: PropTypes.node,
    title: PropTypes.string.isRequired,
    helpText: PropTypes.string,
  };

  static defaultProps = {
    isDisabled: false,
    shouldShowDefinition: false,
    shouldShowIsParentLink: false,
    shouldShowIsRequired: false,
    shouldShowMultiSelect: true,
    shouldShowIsIntegration: false,
    shouldShowTooltip: true,
    shouldShowWarehouseName: false,
  };

  render(): JSX.Element {
    const checkboxHeaderClassnames =
      'simpleDivTable-headerCell simpleDivTable-cell--narrow u-text-align-center';
    const defaultToolTipTitle = this.props.onAddField
      ? 'Add field to bottom'
      : 'Only one field may be added at a time';
    return (
      <div className="simpleDivTable-header">
        <div className="simpleDivTable-headerCell simpleDivTable-header--title">
          {this.props.title}
          {this.props.helpText && (
            <Tooltip title={this.props.helpText}>
              <HelpIcon className="u-mini-spacing-left" />
            </Tooltip>
          )}
          {!this.props.isDisabled && (
            <Tooltip
              container="body"
              disabled={!this.props.shouldShowTooltip}
              placement={TooltipPlacement.TOP}
              title={this.props.onAddToolTip ?? defaultToolTipTitle}
            >
              <BenchlingIcon
                className={classNames('simpleDivTable-addButton', {
                  'simpleDivTable-addButton--disabled': !this.props.onAddField,
                })}
                icon={this.props.toolTipIcon ?? 'compose'}
                onClick={this.props.onAddField || undefined}
              />
            </Tooltip>
          )}
        </div>
        {this.props.shouldShowWarehouseName && <div className="simpleDivTable-headerCell">System name</div>}
        {this.props.shouldShowIsRequired && <div className={checkboxHeaderClassnames}>Required</div>}
        {this.props.shouldShowIsIntegration && <div className={checkboxHeaderClassnames}>Integration</div>}
        {this.props.shouldShowDefinition && this.props.shouldShowMultiSelect && (
          <div className={checkboxHeaderClassnames}>Multi-select</div>
        )}
        {/* TODO(BNCH-11113) Extract parent link awareness to TagSchemaFileSettings level */}
        {this.props.shouldShowIsParentLink && <div className={checkboxHeaderClassnames}>Parent link</div>}
        <div className="simpleDivTable-headerCell">
          {this.props.shouldShowDefinition && <div>Definition</div>}
          {this.props.subheader}
        </div>
        {this.props.shouldShowAdditionalColumn && <div className="simpleDivTable-headerCell" />}
      </div>
    );
  }
}

export default FieldTableHeader;
